export default __webpack_public_path__ + "images/South-American.77410a.jpg";